const LOCAL_STORE = 'rcData';

const loadState = () => {
    try {
        const serializedState = localStorage.getItem(LOCAL_STORE);
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};

const saveState = ({ state }) => {
    try {
        const saveState = { ...state };
        delete saveState.status;
        delete saveState.title;
        delete saveState.titleApi;
        delete saveState.registration;
        delete saveState.registrationApi;
        delete saveState.projectApi;
        const serializedState = JSON.stringify(saveState);
        localStorage.setItem(LOCAL_STORE, serializedState);
    } catch (err) {
        console.log(err);
    }
};

export { loadState, saveState };
